//
// RanksController.js
// BIRD
//
// Generated by Robots v0.
// Copyright (c) SAS Institute Inc. All rights reserved.
//
// DO NOT EDIT THIS FILE. IT IS GENERATED BY ROBOTS.
//
// Disable camelcase rule for generated code.
/* eslint-disable camelcase */
import { createModule } from "@sas-dvr/ltjs-commons/moduleBuilder";
import EventDispatcher from "@sas-dvr/ltjs-commons/events/EventDispatcher";
import "../../lib";
import "./DataDefinitionController";
import "./RankInfo";
import "../../models/dataDefinition/DataItem";
import "./GroupByInfo";

var RanksController = createModule("BIRD::RanksController", ["BIRD::BIRDModelController","BIRD::DataDefinitionController"], EventDispatcher, [
    ,
    ,
    ,
    ,
    {
        getRanks: [[1]],
        getRankForCategory: [1,1],
        getAvailableGroupByCategories: [[1]],
        getRankForGroupBy: [1,1],
        getAvailableRankByMeasures: [[1]],
        removeRank: [0,1],
        getAvailableGroupBy: [[1]],
        applyRank: [0,1],
    },
    ,
    ,
]);
export default RanksController;
